import { formatToTimeZone, parseFromTimeZone } from "date-fns-timezone";

export function getDurationFormat(key: string, _format?: string) {
  const tz = "America/New_York";
  const date = parseFromTimeZone(key, {
    timeZone: tz,
  });
  const format = _format ? _format : "dddd, MMMM D";
  const output = formatToTimeZone(date, format, {
    timeZone: tz,
  });
  return output;
}

export const convertFrom24To12Format = (time24: string) => {
  const result = time24.match(/([0-9]{1,2}):([0-9]{2})/)?.slice(1);
  const [sHours, sMinutes] = result || [];

  const period = +sHours < 12 ? "am" : "pm";
  const hours = +sHours % 12 || 12;
  if (sMinutes === "00") {
    return `${hours}${period}`;
  } else {
    return `${hours}:${sMinutes}${period}`;
  }
};
